import React, { useState } from 'react';

const RadioButtonGroup = ({ options, initialOption, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(initialOption);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="TrackCard">
      {options.map((option) => (
        <div className="TrackBtn" key={option}>
          <input
            type="radio"
            name="radio"
            value={option}
            checked={selectedOption === option}
            onChange={handleChange}
            id={option}
          />
          <label htmlFor={option}>
            {option.charAt(0).toUpperCase() + option.slice(1).replace("Month", " Month")}
          </label>
        </div>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
